import { render, staticRenderFns } from "./DisciplinaAdministrativaDialogContent.vue?vue&type=template&id=21a21b4a"
import script from "./DisciplinaAdministrativaDialogContent.vue?vue&type=script&lang=js"
export * from "./DisciplinaAdministrativaDialogContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports